import {
  QUESTION_NUMERIC_OPEN_ENDED,
  QUESTION_OPEN_ENDED,
  QUESTION_SINGLE,
} from 'data/nodeTypes';

export const PREDEFINED_DEFAULT = 'PREDEFINED_DEFAULT';
export const PREDEFINED_LIKELIHOOD = 'PREDEFINED_LIKELIHOOD';

const predefinedQuestions = [
  {
    type: QUESTION_SINGLE,
    prompt: 'What is your initial reaction to this concept?',
    answers: [
      'Extremely positive',
      'Somewhat positive',
      'Neither positive nor negative',
      'Somewhat negative',
      'Extremely negative',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt:
      'How unique is this concept compared to other products currently available?',
    answers: [
      'Extremely unique',
      'Very unique',
      'Somewhat unique',
      'A little unique',
      'Not unique at all',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt:
      'How appealing is this concept compared to other products currently available?',
    answers: [
      'Extremely appealing',
      'Very appealing',
      'Somewhat appealing',
      'A little appealing',
      'Not at all appealing',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt: 'How much do you like or dislike this concept?',
    answers: [
      'Like a great deal',
      'Like a moderate amount',
      'Like a little',
      'Neither like nor dislike',
      'Dislike a little',
      'Dislike a moderate amount',
      'Dislike a great deal',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt: 'How believable is this concept?',
    answers: [
      'Extremely believable',
      'Moderately believable',
      'Slightly believable',
      'Neither believable nor unbelievable',
      'Slightly unbelievable',
      'Moderately unbelievable',
      'Extremely unbelievable',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt: 'How relevant is this concept to you personally?',
    answers: [
      'Extremely relevant',
      'Moderately relevant',
      'Slightly relevant',
      'Neither relevant nor irrelevant',
      'Slightly irrelevant',
      'Moderately irrelevant',
      'Extremely irrelevant',
    ],
  },
  {
    type: QUESTION_SINGLE,
    prompt:
      'From the list below, which best describes your thinking about this concept?',
    answers: [
      'I need it because nothing else solves this problem',
      'This would be slightly better than what I am currently using',
      'This is essentially the same as what I am currently using',
      'What I am currently using is better than this',
      "I don't see any reason to use this",
    ],
  },
  {
    type: QUESTION_OPEN_ENDED,
    prompt: 'What do you like MOST about this concept?',
  },
  {
    type: QUESTION_OPEN_ENDED,
    prompt: 'What do you like LEAST about this concept?',
  },
];

const likelihoodToPurchaseQuestions = [
  {
    type: QUESTION_SINGLE,
    prompt: 'How likely would you be to buy the product shown here?',
    answers: [
      'Extremely likely',
      'Somewhat likely',
      'Neither likely nor unlikely',
      'Somewhat unlikely',
      'Extremely unlikely',
    ],
  },
  {
    type: QUESTION_NUMERIC_OPEN_ENDED,
    prompt: 'How much would you expect to pay for this product?',
  },
];

export default {
  [PREDEFINED_DEFAULT]: predefinedQuestions,
  [PREDEFINED_LIKELIHOOD]: likelihoodToPurchaseQuestions,
};
